module.exports = __webpack_public_path__ + "static/img/di6.c1215c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/di6.png
// module id = tvYe
// module chunks = 1